import React from 'react'
import PropTypes from 'prop-types'
import { routes } from 'routes'

import { Divider, Drawer, Hidden, makeStyles } from '@material-ui/core'

import {
  DescriptionOutlined,
  CollectionsBookmarkOutlined,
  FaceOutlined,
  MonetizationOnOutlined,
  SettingsOutlined,
  FindInPageOutlined,
  HelpOutline,
  ShoppingCartOutlined,
} from '@material-ui/icons'

import { Profile, SidebarNav } from './components'
import styles from './styles'

const useStyles = makeStyles(styles)

const Sidebar = ({ open, variant, onClose, className, ...rest }) => {
  const classes = useStyles()

  const plansCheckoutPage = React.useMemo(
    () => [
      {
        title: 'Checkout de contratação',
        href: routes.subscribe.main,
        icon: <ShoppingCartOutlined />,
      },
    ],
    [],
  )

  const pages = React.useMemo(
    () => [
      {
        title: 'Assinaturas',
        href: routes.contracts.all,
        icon: <DescriptionOutlined />,
        permission: 'index_contract',
      },
      {
        title: 'Faturas',
        href: routes.invoices.all,
        icon: <MonetizationOnOutlined />,
        permission: 'index',
      },
      {
        title: 'Notas Fiscais',
        href: routes.taxInvoices.all,
        icon: <FindInPageOutlined />,
        permission: 'index_service_tax_invoice',
      },
      {
        title: 'Clientes',
        href: routes.clients.all,
        icon: <FaceOutlined />,
        permission: 'index_customer',
      },
      {
        title: 'Planos',
        href: routes.plans.all,
        icon: <CollectionsBookmarkOutlined />,
        permission: 'index_plan',
      },
    ],
    [],
  )

  const miscPages = React.useMemo(
    () => [
      {
        title: 'Configurações',
        href: routes.settings.all,
        icon: <SettingsOutlined />,
      },
      {
        title: 'Ajuda e Suporte',
        href: 'https://atendimento.yapay.com.br/hc/pt-br',
        icon: <HelpOutline />,
        external: true,
      },
    ],
    [],
  )

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div>
        <Profile />

        <Hidden lgUp>
          <Divider />
          <SidebarNav pages={plansCheckoutPage} onClose={onClose} />
        </Hidden>

        <Divider />
        <SidebarNav pages={pages} onClose={onClose} />

        <Divider />
        <SidebarNav pages={miscPages} logout={true} onClose={onClose} />
      </div>
    </Drawer>
  )
}

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
}

export default Sidebar
